import { useEffect, useMemo } from "react";
import { useRouteError } from "react-router";
import ErrorNotice from "../errors/ErrorNotice";
import { reportUiError, toUiError } from "../errors/uiError";

/** Shown when rendering a route throws. The error is logged, never swallowed. */
export default function RouteErrorPage() {
  const routeError = useRouteError();
  const error = useMemo(() => toUiError(routeError), [routeError]);

  useEffect(() => {
    reportUiError(error);
  }, [error]);

  return (
    <div className="app-main flex min-h-screen items-center justify-center p-6">
      <ErrorNotice
        error={error}
        onRetry={() => {
          window.location.reload();
        }}
        className="w-full max-w-md"
      />
    </div>
  );
}
